import React, { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { api } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";

const AH_LABELS = { en: "AH", ar: "هـ", ur: "ھ", de: "n. H.", fr: "AH" };

/** Compact dual-calendar strip pinned just below the header on the homepage.
 *  Shows today's Gregorian + Hijri dates, fully localised. Auto-refreshes
 *  whenever the active language changes (no manual update required). */
const TodayCalendarCard = () => {
  const [data, setData] = useState(null);
  const { lang, t } = useLanguage();

  useEffect(() => {
    api.get("/calendar/today", { params: { lang } }).then((r) => setData(r.data)).catch(() => {});
  }, [lang]);

  if (!data) return null;

  const ahLabel = AH_LABELS[lang] || AH_LABELS.en;

  return (
    <section
      data-testid="today-calendar-card"
      className="bg-gradient-to-r from-cream via-sand/80 to-cream border-b border-gold/25"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex flex-wrap items-center justify-between gap-x-6 gap-y-2 text-sm">
        <p className="text-[10px] uppercase tracking-[0.3em] text-gold font-semibold">
          {t("today_label")}
        </p>

        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <span
            data-testid="today-gregorian"
            className="inline-flex items-center gap-2 text-forest"
          >
            <Sun className="w-4 h-4 text-clay" />
            <span className="font-medium">{data.gregorian.label}</span>
          </span>

          <span className="w-px h-4 bg-forest/20 hidden sm:inline-block" />

          <span
            data-testid="today-hijri"
            className="inline-flex items-center gap-2 text-forest"
          >
            <Moon className="w-4 h-4 text-gold" />
            <span className="font-medium">
              {data.hijri.day} {data.hijri.month_name} {data.hijri.year} {ahLabel}
            </span>
          </span>
        </div>
      </div>
    </section>
  );
};

export default TodayCalendarCard;
